<app-dialog
  #dialog
  [key]="'modal-derivative-attachments'"
  [action]="'upload-attachment'"
  [headerTheme]="'simple'"
  [title]="'Anexos do Derivativo'"
  [maxWidth]="'800px'">
  <div class="p-4">
    <!-- Upload de Novos Anexos -->
    <div class="mb-4">
      <h5 class="mb-3">Adicionar Novos Anexos</h5>

      <!-- Tipo de Anexo -->
      <div class="mb-3">
        <app-select
          [label]="'Tipo de Anexo (Opcional)'"
          [placeholder]="''"
          [options]="attachmentTypeOptions"
          [allowEmptyPlaceholderSelect]="true"
          [(ngModel)]="selectedAttachmentType">
        </app-select>
      </div>

      <!-- File Upload -->
      <div class="mb-4">
        <app-document-attachment
          [documents]="documents"
          [required]="false"
          [maxFiles]="10"
          [label]="'Selecionar Arquivos'"
          [acceptedFormats]="['.pdf', '.doc', '.docx', '.xls', '.xlsx', '.png', '.jpg', '.jpeg']"
          [emptyLabel]="'Clique para selecionar arquivos ou arraste aqui'"
          [showLoadingSpinner]="false"
          (sendDocument)="onFileSelected($event)"
          (sendRemoveFile)="onRemoveFile($event)">
        </app-document-attachment>
      </div>
    </div>

    <!-- Separador -->
    <hr class="my-4" *ngIf="existingAttachments.length > 0" />

    <!-- Anexos Existentes -->
    <div class="mb-4" *ngIf="existingAttachments.length > 0">
      <h5 class="mb-3">Anexos Existentes</h5>
      <div class="existing-attachments">
        <div
          class="attachment-item d-flex align-items-center justify-content-between p-3 mb-2 border rounded"
          *ngFor="let attachment of existingAttachments">
          <div class="attachment-info d-flex align-items-center">
            <i class="pi pi-file me-2"></i>
            <div>
              <div class="fw-bold">{{ attachment.fileName }}</div>
              <small class="text-muted">
                {{ getAttachmentTypeLabel(attachment.type) }} •
                {{ formatFileSize(attachment.fileSize) }}
              </small>
              <small class="text-muted d-block">
                {{ attachment.name }}.{{ attachment.extension }}
              </small>
              <small class="text-muted d-block mt-1">
                Enviado por: {{ attachment.username }} em {{ attachment.createdAt | vaultDateTime }}
              </small>
            </div>
          </div>
          <div class="attachment-actions">
            <app-button
              [label]="'Download'"
              [icon]="'pi pi-download'"
              [theme]="'dashed'"
              [size]="'small'"
              class="me-2"
              (sendButtonClick)="downloadAttachment(attachment)">
            </app-button>
            <app-button
              [label]="'Remover'"
              [icon]="'pi pi-trash'"
              [theme]="'danger'"
              [size]="'small'"
              (sendButtonClick)="deleteAttachment(attachment)">
            </app-button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #footer>
    <div class="dialog__footer">
      <app-button
        [label]="'Cancelar'"
        [theme]="'white'"
        class="me-2"
        (sendButtonClick)="dialogRef?.close()">
      </app-button>
      <app-button
        [disabled]="!isFormValid()"
        [isLoading]="isLoading"
        [loadingText]="'Enviando...'"
        [label]="'Enviar Anexos'"
        [icon]="'pi pi-upload'"
        (sendButtonClick)="submitUpload()">
      </app-button>
    </div>
  </ng-template>
</app-dialog>
